import boletaApi from "./boletaApi";

export const getOwnInvoicesByStatus = async (idCompany) => {
  try {
    const res = await boletaApi.get("/getOwnInvoicesByStatus", {
      params: { idCompany },
    });
    return { data: res.data };
  } catch (error) {
    console.error("Error en getOwnInvoicesByStatus:", error);
    return { data: [] };
  }
};
